import growthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

export const isArkoseBotManagerEnabled = () => growthAcquisitionExperiments.preview('shouldEnableArkoseBotManager');
